import { TextField, Typography, Container, Button, CircularProgress, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../Actions/Auth';
import PasswordIcon from '@mui/icons-material/Password';
import EmailIcon from '@mui/icons-material/Email';
import { Navbar } from "../../components/Navbar/Navbar";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(state => state.user.isLoading);

  const handleLogin = event => {
    event.preventDefault();
    navigate('/login');
  };

  const handleSignUp = event => {
    event.preventDefault();
    navigate('/sign-in');
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validate = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Required'),
    password: Yup.string().required('Password is required'),
  });

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validate,
    onSubmit: (values, onSubmitProps) => {
      dispatch(
        login(
          {
            email: values.email,
            password: values.password,
          },
          navigate,
        ),
      );

      // setOpen(true);
      onSubmitProps.resetForm();
    },
  });

  return (
    <div>
      <Navbar />
      <Container
        sx={{
          width: ['100%', '50%', '40%', '30%'],
          height: ['100%', '100%', '100%'],
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          my: 20,
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            marginTop: ['80px', '80px', '80x'],
            paddingLeft: '0px',
            paddingRight: '0px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'Column',
            boxShadow: '0px 3px 45px #71380C12',
          }}
        >
          <div style={{ width: '100%' }}>
            <Button
              variant="contained"
              size="large"
              sx={{
                width: '50%',
                backgroundColor: '#FF7345',
                fontFamily: 'Sora',
                '&:hover': {
                  backgroundColor: '#d95429',
                },
                borderRadius: '6px 0px 0px 0px',
                boxShadow: '0px 0px 0px 0px',
              }}
              onClick={handleLogin}
            >
              Login
            </Button>
            <Button
              onClick={handleSignUp}
              variant="contained"
              size="large"
              sx={{
                width: '50%',
                backgroundColor: '#ffc4b0',
                color: '#FF7345',
                fontFamily: 'Sora',
                '&:hover': {
                  backgroundColor: '#d95429',
                  color: 'white',
                },
                borderRadius: '0px 6px 0px 0px',
                boxShadow: '0px 0px 0px 0px',
              }}
            >
              Sign up
            </Button>
          </div>
          <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
            <Typography sx={{ marginTop: '20px', fontWeight: '700', fontFamily: 'Sora', px: 2 }} variant="h5">
              Welcome <span style={{ color: '#FF7345' }}>Back</span>
            </Typography>
            <div style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
              <TextField
                id="email"
                name="email"
                placeholder="Email Id"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                // error="This is error"
                // helperText="There is error"

                sx={{
                  width: '100%',
                  borderRadius: '5px',
                  backgroundColor: '#F6F7F9',
                  '& input::placeholder': {
                    fontFamily: 'Sora',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    marginTop: '30px',
                   
                  }, outlineColor: '#FF7345',
                  
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
               sx={{
                width: '100%',
                borderRadius: '5px',
                backgroundColor: '#F6F7F9',
                '& input::placeholder': {
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  fontWeight: 'bold',
                  marginTop: '30px',
                 
                }, outlineColor: '#FF7345',
                marginTop:"30px",
               
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <PasswordIcon />
                  </InputAdornment>
                ),
              }}
                id="password"
                name="password"
                type="password"
                placeholder="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                // error="This is error"
                // helperText="There is error
                
              />
              <Typography  sx={{width:"100%",display:"flex",justifyContent:"left",marginTop:2,cursor:"pointer",fontFamily:"Sora",
            color:"#FF7345",'&:hover':{color:"#d95429"}
            }}
            onClick={()=>navigate('/forgot-password')}
            
            >Forgot Password ??</Typography>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            
              {loading ? (
                <CircularProgress></CircularProgress>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    width: '100%',
                    margin: '10px',
                    backgroundColor: '#FF7345',
                    fontFamily: 'Sora',
                    marginBottom: '20px',
                boxShadow:'none',

                    display: 'flex',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: '#d95429',
                    },
                  }}
                  type="submit"
                >
                  Login
                </Button>
              )}
              
            </div>
           
          </form>
        </div>
      </Container>
    </div>
  );
};
export default LoginPage;
